import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import GroupAdminHeader from "../../../../Comman/Header";
import GroupAdminSidebar from "../../../../Comman/Sidebar";
import GroupAdminUperSide from "../../../../Comman/UperSide";
import Swal from "sweetalert2";
import api from "../../../../../CommonApi/axios";
import $ from "jquery";
import MaterialTable from "material-table";
import headers from "../../../../../CommonApi/headers";
import { useStyles } from "../../../../Comman/TableuseStyles";
import { useMediaQuery } from "react-responsive";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { ListItemIcon, ListItemText } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from "moment";
import { Menu, MenuItem } from "@mui/material";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { TbFileDownload } from "react-icons/tb";
import useDrawer from "../../../../../context/DrawerContext";
// import "./TourGroup.css"
window.jquery = window.$ = $;


const ActionIcon = () => {
    // Your custom icon component using SVG
    return (
        <button
            className="btn btn-outline btn-outline-secondary px-2 py-1"

        >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.28149 4.7998C2.42233 4.7998 1.96315 5.81172 2.52891 6.45831L6.94637 11.5068C7.50415 12.1443 8.49581 12.1443 9.05359 11.5068L13.4711 6.45831C14.0368 5.81173 13.5776 4.7998 12.7185 4.7998H3.28149Z" fill="#667085" />
            </svg>
        </button>
    );
};


function GroupAdminTourGroupReport() {


    $(document).ready(function () {
        $(".filterme").keypress(function (eve) {
            if (
                ((eve.which != 46 || $(this).val().indexOf(".") != -1) &&
                    (eve.which < 48 || eve.which > 57)) ||
                (eve.which == 46 && $(this).caret().start == 0)
            ) {
                eve.preventDefault();
            }
            $(".filterme").keyup(function (eve) {
                if ($(this).val().indexOf(".") == 0) {
                    $(this).val($(this).val().substring(1));
                }
            });
        });
    });

    const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleMenuOpen = (event, rowData) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(rowData);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const [showFilter, setShowFilter] = useState(false);

    const toggleFilter = () => {
        setShowFilter(prevShowFilter => !prevShowFilter);
    }

    useEffect(() => {
        TourList();
    }, []);

    const [tourList, setTourList] = useState([]);

    const [filteSetData, setFilteSetData] = useState({
        company_id: { label: "All...", value: "" },
        client_id: { label: "All...", value: "" },
        reference: "",
        invoice_number: "",
        dinning_location_id: { label: "All...", value: "" },
        cooking_location_id: { label: "All...", value: "" },
        status_id: { label: "All...", value: "" },
        payment_status_id: { label: "All...", value: "" },
        action: false,
        from_date : "",
        to_date :""
    });

    const [filterData, setFilterData] = useState({
        company_id: "",
        client_id: "",
        reference: "",
        invoice_number: "",
        dinning_location_id: "",
        cooking_location_id: "",
        payment_status_id: "",
        status_id: "",
        from_date : "",
        to_date :""
    });

    useEffect(() => {
        TourList(); // Initial loading of tour list
        AllList(); // Loading all necessary data for filters
    }, []);

    // Function to fetch tour list based on filters
    function TourList() {
      // console.log("filterData" ,filterData);
      // return

        api.post(`/groupadmin/tourgroup/list_tour`, filterData, { headers })
            .then((res) => {
                Swal.close()
                const tableData = res?.data?.data;
                setTourList(tableData);
            })
            .catch((err) => {
                Swal.close()

            });
    }

    const [company, setCompany] = useState([]);
    const [client, setClient] = useState([]);
    const [location, setLocation] = useState([]);
    const [status, setStatus] = useState([]);
    const [paymentstatus, setPaymentStatus] = useState([]);

    async function AllList() {
        try {
            const response = await api.post(`/groupadmin/tourgroup/all_setup_list`, {}, { headers });
            const AllList = response?.data?.data;
            setCompany(AllList.company);
            setClient(AllList.client);
            setLocation(AllList.location);
            setStatus(AllList.status);
            setPaymentStatus(AllList.paymentstatus);
        } catch (err) {

        }
    }

    // Function to handle changes in filter options
    const handleSelectChange = (fieldName, selectedOption) => {
        setFilteSetData(prevState => ({
            ...prevState,
            [fieldName]: selectedOption // Save the full selectedOption in formData
        }));
        setFilterData(prevState => ({
            ...prevState,
            [fieldName]: selectedOption.value // Save only the value in filterData
        }));
    };

    // Function to handle changes in filter input values
    const handleInputChange = (fieldName, value) => {
        setFilteSetData(prevState => ({
            ...prevState,
            [fieldName]: value // Save only the value in formData
        }));
        setFilterData(prevState => ({
            ...prevState,
            [fieldName]: value // Save only the value in filterData
        }));
    };

    // Function to handle applying filters and fetching tour list
    function handleFilterData() {
        Swal.fire({
            title: 'Please wait...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading();
            }
        });
        TourList(); // Fetch tour list based on the applied filters
    }

    useEffect(() => {
        // Check if all fields are blank
        const allFieldsBlank = Object.values(filterData).every(value => value === "");

        // If all fields are blank, call TourList
        if (allFieldsBlank) {

            TourList();
        }
    }, [filterData]);

    function handleFilterDataClear() {
        Swal.fire({
            title: 'Please wait...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading();
            }
        });

        // Reset filter data
        setFilterData({
            company_id: "",
            client_id: "",
            reference: "",
            invoice_number: "",
            dinning_location_id: "",
            cooking_location_id: "",
            payment_status_id: "",
            status_id: "",
            from_date  :"",
            to_date : ""
        });
        // Reset filter set data after filterData has been updated
        setFilteSetData({
            company_id: { label: "All...", value: "" },
            client_id: { label: "All...", value: "" },
            reference: "",
            invoice_number: "",
            dinning_location_id: { label: "All...", value: "" },
            cooking_location_id: { label: "All...", value: "" },
            status_id: { label: "All...", value: "" },
            payment_status_id: { label: "All...", value: "" },
            from_date: "",
            to_date : ""
        });

    }


    let history = useHistory();

    const [selectedCheckBox, setSelectedCheckBox] = useState([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
    const [selectedCurrncyId, setSelectedCurrncyId] = useState(null);
    const [selectedClientInfoId, setSelectedClientInfoId] = useState(null);

    const handleCheckBoxChange = (event, rowData) => {
        const { checked } = event.target;

        if (checked) {
            // Add to selectedCheckBox array if checked
            setSelectedCheckBox([...selectedCheckBox, rowData._id]);
            setSelectedCompanyId(rowData.companyinfo._id); // Update selectedCompanyId when a checkbox is checked
            setSelectedCurrncyId(rowData.currency_id); // Update selectedCurrncyId when a checkbox is checked
            setSelectedClientInfoId(rowData.clientinfo._id); // Update selectedClientInfoId when a checkbox is checked
        } else {
            // Remove from selectedCheckBox array if unchecked
            setSelectedCheckBox(selectedCheckBox.filter(id => id !== rowData._id));

            // Check if there are no checkboxes checked, then set selectedCompanyId, selectedCurrncyId, and selectedClientInfoId to null
            if (selectedCheckBox.length === 1 && selectedCheckBox[0] === rowData._id) {
                setSelectedCompanyId(null);
                setSelectedCurrncyId(null);
                setSelectedClientInfoId(null);
            }
        }
    };


    // Modify the rendering logic of checkboxes to disable based on selected company ID
    const columns = [
      //   {
      //       title: (
      //           <input
      //               type="checkbox"
      //               style={{
      //                   width: '13px',
      //                   height: '13px',
      //               }}
      //               disabled
      //           />
      //       ),
      //       render: (rowData) => (
      //           // Conditionally render checkbox in body rows
      //           <input
      //               type="checkbox"
      //               style={{
      //                   width: '12px',
      //                   height: '12px',
      //               }}
      //               title={rowData.invoice_number ? 'Invoice generated' : 'No invoice generated'}
      //               checked={selectedCheckBox.includes(rowData._id)}
      //               onChange={(e) => handleCheckBoxChange(e, rowData)}
      //               disabled={
      //                   (selectedCompanyId && rowData.companyinfo._id !== selectedCompanyId) ||
      //                   (selectedCurrncyId && rowData.currency_id !== selectedCurrncyId) ||
      //                   (selectedClientInfoId && rowData.clientinfo._id !== selectedClientInfoId) ||
      //                   rowData.invoice_number !== ''
      //               }
      //           />
      //       ),
      //       sorting: false
      //   },
        {
            title: "⁠Payment Status",
            field: "payment_status",
        },
        {
            title: "Status",
            field: "status",
        },
        {
            title: 'Date',
            render: (rowData) => {
                return (
                    <>
                        {moment(rowData.tour_date).format('DD/MM/YYYY')}
                    </>
                )
            },
        },
        {
            title: 'Reference',
            render: (rowData) => {
                return (
                    <>
                        <div
                        //     style={{ color: "blue", cursor: "pointer" }}
                        //     onClick={() =>
                        //         history.push(
                        //             `/group_admin/tour/details/${rowData?._id}`
                        //         )
                        //     }
                        >
                            {rowData?.reference}
                        </div>
                    </>
                )
            },
        },
        {
            title: 'Company',
            render: (rowData) => {
                return (
                    <>
                        {rowData?.companyinfo?.company_name ? rowData?.companyinfo?.company_name : '---'}
                    </>
                )
            },
        },
        {
            title: "Client Name",
            render: (rowData) => {
                return (
                    <>
                        {rowData?.clientinfo?.client_name ? rowData.clientinfo.client_name : '---'}
                    </>
                )
            },
        },
        {
            title: 'Dinning Location',
            field: 'dinning_location',
        },
        {
            title: 'Cooking Location',
            field: 'cooking_location',
        },
        {
            title: 'Meal',
            field: 'meal_name',
        },
        {
            title: 'Total Pax',
            field: 'total_pax',
        },
        {
            title: 'Comments',
            render: (rowData) => {
                // /group_admin/tour/comments/:tour_id
                return (
                    <>
                        <span className="badge badge-square badge-secondary p-4 fs-5" 
                        // style={{ color: "blue", cursor: "pointer" }}
                        //     onClick={() =>
                        //         history.push(
                        //             `/group_admin/tour/comments/${rowData?._id}`
                        //         )
                        // }
                            >
                            {rowData?.comment_count}
                        </span>
                    </>
                )
            },
        },
        {
            title: "Invoice Number",
            render: (rowData) => {
                return (
                    <>
                        {rowData?.invoice_number ? (

                            <a style={{ color: "blue", cursor: "pointer" }} href="#" onClick={() => window.open(rowData.invoice_url)}>{rowData.invoice_number}</a>
                            // <a style={{ color: "blue", cursor: "pointer" }} href={`http://docs.google.com/gview?url=${rowData.invoice_url}&embedded=true#:0.page.20`} target="_blank">{rowData.invoice_number}</a>
                        ) : '---'}
                    </>
                )
            },
        },
    ];

    function deleteTour(_id) {
        setAnchorEl(null);
        // Check if the selectedRow exists and its invoice_number is not blank
        if (selectedRow && selectedRow.invoice_number === '') {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    api
                        .post(`/groupadmin/tourgroup/delete_tour`, { tour_id: _id }, { headers })
                        .then((result) => {
                            Swal.fire({
                                position: "center-center",
                                icon: "success",
                                title: "Tour has been deleted successfully.",
                                showConfirmButton: false,
                                timer: 1500,
                            });
                            TourList();
                        })
                        .catch((err) => {
                            if (err.response) {
                                toast.error(err?.response?.data?.error?.message, {
                                    position: "top-center",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                });
                            }
                        });
                }
            });
        } else {

            // Show an error message if the invoice_number is blank
            toast.error("Cannot delete the tour because an invoice has been generated. Please delete the invoice first.", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }

    function handleEditTour(_id) {
        setAnchorEl(null);
        if (selectedRow?.invoice_number === '') {
            history.push(`/group_admin/tour/edit/${_id}`)
        } else {
            history.push(`/group_admin/tour/edit/${_id}`)
        }
    }

    function deleteInvoice(invoice_number) {
        setAnchorEl(null);
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                api
                    .post(`/groupadmin/tourgroup/delete_invoice`, { invoice_number: invoice_number }, { headers })
                    .then((result) => {
                        console.log(result)
                        Swal.fire({
                            position: "center-center",
                            icon: "success",
                            title: "Tour Invoice has been deleted successfully.",
                            showConfirmButton: false,
                            timer: 1500,
                        });
                        TourList();
                    })
                    .catch((err) => {
                        console.log(err)
                        if (err.response) {
                            toast.error(err?.response?.data?.error?.message, {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        }
                    });
            }
        });
    }

    // const [toastShown, setToastShown] = useState(false);
    function GenerateInvoice() {
        Swal.fire({
            title: 'Please wait...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading();
            }
        });

        api
            .post(`groupadmin/tourgroup/invoice_generate`, { tourids: selectedCheckBox }, { headers })
            .then((res) => {

                Swal.close()
                setLoading(false)
                localStorage.setItem("tourids", selectedCheckBox);
                history.push(`/group_admin/tour/invoice-generate`)

                // Redirect to the CompanyList page
            })
            .catch((errs) => {
                setLoading(false)
                Swal.close()
                if (errs.response) {
                    console.log(errs.response)
                    console.log('yes')
                    toast.error(errs?.response.data?.error?.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",

                    });
                }
            });


    }

    const [sendInvoiceModal, setSendInvoiceModal] = useState(false)
    const [invoiceNumber, setInvoiceNumber] = useState('')
    const [errorForm, setErrorForm] = useState({});
    const [loading, setLoading] = useState(false);

    const [mailData, setMailData] = useState({
        email: '',
    });

    const [apiError, setApiError] = useState('');
    const errorDiv = apiError ? (
        <div className="text-center alert alert-danger">{apiError}</div>
    ) : (
        ""
    );

    const handleEmailInvoice = (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorForm(null);
        setApiError('')
        // Check for validation errors for each field
        const errors = {};

        if (mailData.email.trim() === '') {
            errors.email = "Email is a required.";
        } else {
            // Email validation regex pattern
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            // Check email format
            if (!emailPattern.test(mailData.email)) {
                errors.email = "Please enter a valid email address.";
            }
        }

        // Update formErrors state with individual field errors
        setErrorForm(errors);

        // If there are any errors, prevent form submission
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        Swal.fire({
            title: 'Please wait...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading();
            }
        });

        const data = {
            email: mailData.email,
            invoice_number: invoiceNumber
        }

        api
            .post(`/groupadmin/tourgroup/sendmail_invoice`, data, { headers })
            .then((res) => {
                setSendInvoiceModal(false)
                setMailData(prevmailData => ({
                    ...prevmailData,
                    email: '' // Set email to blank
                }));
                setInvoiceNumber('')
                Swal.fire({
                    position: "top-center",
                    icon: "success",
                    title: "Tour Invoice Send successfully",
                    showConfirmButton: false,
                    timer: 1500,
                }).then(() => {
                    setLoading(false)
                });
                // Redirect to the CompanyList page
            })
            .catch((err) => {
                setLoading(false)
                if (err.response) {
                    Swal.close()
                    setApiError(err?.response?.data?.error?.message)
                }
            });
    }

    console.log("tourList" ,tourList)

    function downloadCSV() {
        const headers = ["Date", "Reference ", "Company","Client" ,"Referral Code" ,"Dining Location", 
        "Cooking Location",
         "Meal", "Tour Manager", "Tour manager Number","Total Adults" , "Total Kids" ,"Total Pax", 
         "Veg", "Non Veg", "jain" , "Adult Price" , "Kid Price" ,"Currency" ,"Total Price" , "Group Status" ,
          "Payment Status" , "Invoice Number"];
        const csvData = [headers];

        tourList.forEach((item) => {

            const { tour_date, reference, companyinfo, clientinfo,referral_code , dinning_location, cooking_location, 
                  meal_name, tour_manager, tour_manager_no, adult,kid , total_pax, veg, non_veg, jain , adult_price ,
                  kid_price,
                  currency ,total , status ,payment_status ,invoice_number} = item;
            const date = moment(tour_date).format('DD/MM/YYYY');
            const company_name = companyinfo ? companyinfo.company_name : '';
            const row = [date, reference, companyinfo?.company_name, clientinfo?.client_name ,
                  referral_code , dinning_location, cooking_location, meal_name, tour_manager, tour_manager_no, 
                  adult,kid,total_pax, veg, non_veg, jain ,adult_price , kid_price, currency ,total ,status ,
                  payment_status ,invoice_number];
            csvData.push(row);
        });

        // Convert data to CSV format
        const csvContent = csvData.map(row => row.join(",")).join("\n");

        // Create a Blob containing the CSV data
        const blob = new Blob([csvContent], { type: "text/csv" });

        const todayDate = moment().format('DD_MM_YYYY');
        const fileName = `Tour_group_report_${todayDate}.csv`;

        // Create a download link for the Blob
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = fileName; // Set the filename here

        // Append the link to the body and trigger the click event
        document.body.appendChild(a);
        a.click();

        // Clean up by removing the link and revoking the URL
        window.URL.revokeObjectURL(url);
    }

    const { drawerPos, handleDrawer , mainClassCustome } = useDrawer();


    return (
        <React.Fragment>
            <div
                id="kt_body"
                className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-enabled aside-fixed"
            >
                <div className="d-flex flex-column flex-root">
                    <div className="page d-flex flex-row flex-column-fluid">
                        <GroupAdminSidebar drawerPos={drawerPos} handleDrawer={handleDrawer}/>
                        <div
                            className="wrapper d-flex flex-column flex-row-fluid"
                            id="kt_wrapper"
                        >
                            <GroupAdminHeader />
                            <div
                                className=" d-flex flex-column flex-column-fluid"
                                id="kt_content"
                            >
                                <div id="kt_content_container" className="mx-7">
                                <main style={{position : "initial"}} className={mainClassCustome.join(" ")}>
                                    <div className="d-flex mb-5" style={{ justifyContent: 'space-between' }}>
                                        <div>
                                            <h1
                                                className="anchor fw-bolder"
                                                id="vertical-horizontal-scroll"
                                            >
                                               Tour Group Reports
                                            </h1>

                                        </div>

                                    </div>
                                    <div>


                                        <div className="tab-content" id="myTabContent">

                                            <div
                                                className="tab-pane fade show active"
                                                id="kt_tab_pane_1"
                                                role="tabpanel"
                                            >

                                                <div className="card card-docs mb-2">
                                                    <div className="card-header">

                                                        <h3
                                                            className="card-title align-items-start flex-column"
                                                            id="vertical-horizontal-scroll"
                                                        >
                                                            Tour Group List
                                                        </h3>
                                                        <div class="card-toolbar">
                                                            <button
                                                                className="btn btn-outline btn-outline-secondary me-4"
                                                                onClick={toggleFilter}
                                                            >
                                                                <svg width="24" height="24" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M54.8573 11.4287H9.14307L27.4288 33.0516V50.2859L36.5716 54.8573V33.0516L54.8573 11.4287Z" fill="black" stroke="black" stroke-width="2.28571" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>

                                                            </button>
                                                            <button
                                                                className="btn btn-outline btn-outline-success pb-2 me-4"
                                                                onClick={downloadCSV}
                                                            >
                                                                <TbFileDownload className="me-1 fs-1" />
                                                                <span className="">
                                                                    Csv
                                                                </span>
                                                            </button>
                                                           
                                                        </div>


                                                    </div>
                                                    <div className={`filter p-10 p-lg-10 ${showFilter ? 'fadeIn' : 'fadeOut'}`}>
                                                        <div className="card">
                                                            <div style={{padding : 0 }} className="card-body mb-2">
                                                                <div className="row">
                                                                <div className="col-12 col-sm-4 col-md-2 mb-5">
                                                                        <label className="form-label">
                                                                            Start Date
                                                                        </label>
                                                                        <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        placeholder='Date'
                                                                        required
                                                                        name="tour_date"
                                                                        value={filteSetData.from_date}
                                                                        onChange={(e) => handleInputChange('from_date', e.target.value)}

                                                                    />
                                                                    </div>

                                                                    <div className="col-12 col-sm-4 col-md-2 mb-5">
                                                                        <label className="form-label">
                                                                            End Date
                                                                        </label>
                                                                        <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        placeholder='Date'
                                                                        required
                                                                        name="tour_date"
                                                                        value={filteSetData.to_date}
                                                                        onChange={(e) => handleInputChange('to_date', e.target.value)}

                                                                    />
                                                                    </div>
                                                                    <div className="col-12 col-sm-4 col-md-2 mb-5">
                                                                        <label className="form-label">
                                                                            Reference
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder='Reference'
                                                                            required
                                                                            name="reference"
                                                                            value={filteSetData.reference}
                                                                            onChange={(e) => handleInputChange('reference', e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <div className="col-12 col-sm-4 col-md-3 mb-5">
                                                                        <label className="form-label">
                                                                            Select Company
                                                                        </label>
                                                                        <Select
                                                                            id="select2"
                                                                            className="search-line"
                                                                            placeholder="Search Company..."
                                                                            name="company_id"
                                                                            value={filteSetData.company_id}
                                                                            defaultValue={{ label: "All...", value: "" }}
                                                                            onChange={(selectedOption) => handleSelectChange('company_id', selectedOption)}
                                                                            options={[
                                                                                { label: "All...", value: "" }, // "Choose..." option with blank value
                                                                                ...company.map(item => ({
                                                                                    label: item.name,
                                                                                    value: item._id
                                                                                }))
                                                                            ]}
                                                                            styles={{
                                                                                menu: provided => ({
                                                                                    ...provided,
                                                                                    zIndex: 9999, // Set a higher z-index value
                                                                                    maxHeight: '155px' // Set the maximum height of the dropdown menu
                                                                                }),
                                                                                menuList: provided => ({
                                                                                    ...provided,
                                                                                    maxHeight: '155px', // Set the height of the dropdown menu list
                                                                                    overflowY: 'auto' // Enable vertical scrolling
                                                                                })
                                                                            }}

                                                                        />
                                                                    </div>
                                                                    <div className="col-12 col-sm-4 col-md-3 mb-5">
                                                                        <div form-gorup>

                                                                        </div>
                                                                        <label className="form-label">
                                                                            Select Client
                                                                        </label>
                                                                        <Select
                                                                            required
                                                                            className="search-line"
                                                                            placeholder="Search Client..."
                                                                            name="client_id"
                                                                            value={filteSetData.client_id}
                                                                            defaultValue={{ label: "All...", value: "" }}
                                                                            onChange={(selectedOption) => handleSelectChange('client_id', selectedOption)}
                                                                            options={[
                                                                                { label: "Choose...", value: "" }, // "Choose..." option with blank value
                                                                                ...client.map(item => ({
                                                                                    label: item.name,
                                                                                    value: item._id
                                                                                }))
                                                                            ]}
                                                                            styles={{
                                                                                menu: provided => ({
                                                                                    ...provided,
                                                                                    zIndex: 9999, // Set a higher z-index value
                                                                                    maxHeight: '155px' // Set the maximum height of the dropdown menu
                                                                                }),
                                                                                menuList: provided => ({
                                                                                    ...provided,
                                                                                    maxHeight: '155px', // Set the height of the dropdown menu list
                                                                                    overflowY: 'auto' // Enable vertical scrolling
                                                                                })
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    

                                                                    <div className="col-12 col-sm-4 col-md-2 mb-5">
                                                                        <label className="form-label">
                                                                            Select Status
                                                                        </label>
                                                                        <Select
                                                                            id="select2"
                                                                            className="search-line"
                                                                            placeholder="Search Status..."
                                                                            name="status_id"
                                                                            value={filteSetData.status_id}
                                                                            defaultValue={{ label: "All...", value: "" }}
                                                                            onChange={(selectedOption) => handleSelectChange('status_id', selectedOption)}
                                                                            options={[
                                                                                { label: "All...", value: "" }, // "Choose..." option with blank value
                                                                                ...status.map(item => ({
                                                                                    label: item.name,
                                                                                    value: item._id
                                                                                }))
                                                                            ]}
                                                                            styles={{
                                                                                menu: provided => ({
                                                                                    ...provided,
                                                                                    zIndex: 9999, // Set a higher z-index value
                                                                                    maxHeight: '155px' // Set the maximum height of the dropdown menu
                                                                                }),
                                                                                menuList: provided => ({
                                                                                    ...provided,
                                                                                    maxHeight: '155px', // Set the height of the dropdown menu list
                                                                                    overflowY: 'auto' // Enable vertical scrolling
                                                                                })
                                                                            }}
                                                                        />
                                                                    </div>

                                                                    <div className="col-12 col-sm-4 col-md-2 mb-5">
                                                                        <label className="form-label">
                                                                            Payment Status
                                                                        </label>
                                                                        <Select
                                                                            id="select2"
                                                                            className="search-line"
                                                                            placeholder="Search Payment Currency..."
                                                                            name="payment_status_id"
                                                                            value={filteSetData.payment_status_id}
                                                                            defaultValue={{ label: "All...", value: "" }}
                                                                            onChange={(selectedOption) => handleSelectChange('payment_status_id', selectedOption)}
                                                                            options={[
                                                                                { label: "All...", value: "" }, // "Choose..." option with blank value
                                                                                ...paymentstatus.map(item => ({
                                                                                    label: item.name,
                                                                                    value: item._id
                                                                                }))
                                                                            ]}
                                                                            styles={{
                                                                                menu: provided => ({
                                                                                    ...provided,
                                                                                    zIndex: 9999, // Set a higher z-index value
                                                                                    maxHeight: '155px' // Set the maximum height of the dropdown menu
                                                                                }),
                                                                                menuList: provided => ({
                                                                                    ...provided,
                                                                                    maxHeight: '155px', // Set the height of the dropdown menu list
                                                                                    overflowY: 'auto' // Enable vertical scrolling
                                                                                })
                                                                            }}
                                                                        />
                                                                    </div>

                                                                    <div className="col-12 col-sm-4 col-md-2 mb-5">
                                                                        <label className="form-label">
                                                                            Invoice Number
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder='Invoice Number'
                                                                            required
                                                                            name="invoice_number"
                                                                            value={filteSetData.invoice_number}
                                                                            onChange={(e) => handleInputChange('reference', e.target.value)}
                                                                        />
                                                                    </div>
                                                                    

                                                                    <div className="col-12 col-sm-4 col-md-3 mb-5">
                                                                        <label className="form-label">
                                                                            Select Dining Location
                                                                        </label>
                                                                        <Select
                                                                            id="select2"
                                                                            className="search-line"
                                                                            placeholder="Search Dining Location..."
                                                                            name="dinning_location_id"
                                                                            value={filteSetData.dinning_location_id}
                                                                            defaultValue={{ label: "All...", value: "" }}
                                                                            onChange={(selectedOption) => handleSelectChange('dinning_location_id', selectedOption)}
                                                                            options={[
                                                                                { label: "All...", value: "" }, // "Choose..." option with blank value
                                                                                ...location.map(item => ({
                                                                                    label: item.name,
                                                                                    value: item._id
                                                                                }))
                                                                            ]}
                                                                            styles={{
                                                                                menu: provided => ({
                                                                                    ...provided,
                                                                                    zIndex: 9999, // Set a higher z-index value
                                                                                    maxHeight: '155px' // Set the maximum height of the dropdown menu
                                                                                }),
                                                                                menuList: provided => ({
                                                                                    ...provided,
                                                                                    maxHeight: '155px', // Set the height of the dropdown menu list
                                                                                    overflowY: 'auto' // Enable vertical scrolling
                                                                                })
                                                                            }}
                                                                        />
                                                                    </div>

                                                                    <div className="col-12 col-sm-4 col-md-3 mb-5">
                                                                        <label className="form-label">
                                                                            Select Cooking Location
                                                                        </label>
                                                                        <Select
                                                                            required
                                                                            className="search-line"
                                                                            placeholder="Search Cooking Location..."
                                                                            name="cooking_location_id"
                                                                            value={filteSetData.cooking_location_id}
                                                                            defaultValue={{ label: "All...", value: "" }}
                                                                            onChange={(selectedOption) => handleSelectChange('cooking_location_id', selectedOption)}
                                                                            options={[
                                                                                { label: "All...", value: "" }, // "Choose..." option with blank value
                                                                                ...location.map(item => ({
                                                                                    label: item.name,
                                                                                    value: item._id
                                                                                }))
                                                                            ]}
                                                                            styles={{
                                                                                menu: provided => ({
                                                                                    ...provided,
                                                                                    zIndex: 9999, // Set a higher z-index value
                                                                                    maxHeight: '155px' // Set the maximum height of the dropdown menu
                                                                                }),
                                                                                menuList: provided => ({
                                                                                    ...provided,
                                                                                    maxHeight: '155px', // Set the height of the dropdown menu list
                                                                                    overflowY: 'auto' // Enable vertical scrolling
                                                                                })
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    
                                                                </div>

                                                            </div>
                                                            <div className="card-footer text-center pb-0">
                                                                <button
                                                                    type="submit"
                                                                    id="kt_modal_new_address_submit"
                                                                    className="btn btn-primary me-5"
                                                                    disabled={loading}
                                                                    onClick={handleFilterData}
                                                                >
                                                                    Search
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={handleFilterDataClear}
                                                                    id="kt_modal_new_max_discount_value_submit"
                                                                    className="btn btn-danger"
                                                                >
                                                                    Clear
                                                                </button>
                                                                
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="card-body fs-6 pt-0 px-0 px-lg-0 text-gray-700">

                                                        <MaterialTable
                                                            title=""
                                                            data={tourList}
                                                            columns={columns}
                                                            options={{
                                                                sorting: true,
                                                                search: false,
                                                                paging: true,
                                                                pageSizeOptions: [2, 5, 10, 20, 25, 50, 100],
                                                                pageSize: 5,
                                                                emptyRowsWhenPaging: false,
                                                                paginationType: "stepped",
                                                                showFirstLastPageButtons: false,
                                                                paginationPosition: "bottom",
                                                                actionsColumnIndex: -1,
                                                                draggable: false,
                                                                headerStyle: {
                                                                    background: "darkgray",
                                                                    color: "#fff",
                                                                    fontSize: "15px",
                                                                    paddingLeft: "10px",
                                                                    paddingRight: "20px"
                                                                },
                                                                toolbar: false, // Disable built-in toolbar
                                                            }}
                                                            // actions={[
                                                            //     {
                                                            //         icon: () => <ActionIcon />,
                                                            //         tooltip: 'More',
                                                            //         onClick: (event, rowData) => handleMenuOpen(event, rowData)
                                                            //     }
                                                            // ]}
                                                        />
                                                        <Menu
                                                            id="simple-menu"
                                                            anchorEl={anchorEl}
                                                            className="rounded border border-2"
                                                            open={Boolean(anchorEl)}
                                                            onClose={handleMenuClose}

                                                        >
                                                            <MenuItem className="py-2 px-4" onClick={() => handleEditTour(selectedRow._id)} style={{ display: 'flex', flexDirection: 'row' }}>
                                                                <ListItemIcon>
                                                                    <EditIcon />
                                                                </ListItemIcon>
                                                                <ListItemText
                                                                    primary={<span style={{ fontSize: '14px', fontFamily: 'inherit', fontWeight: 500 }}>Edit Tour</span>}
                                                                />
                                                            </MenuItem>
                                                            <MenuItem className="py-2 px-4" onClick={() => deleteTour(selectedRow._id)} style={{ display: 'flex', flexDirection: 'row' }}>
                                                                <ListItemIcon>
                                                                    <DeleteIcon />
                                                                </ListItemIcon>
                                                                <ListItemText
                                                                    primary={<span style={{ fontSize: '14px', color: '#D92D20', fontFamily: 'inherit', fontWeight: 500 }}>Delete Tour</span>}
                                                                />
                                                            </MenuItem>
                                                            <MenuItem
                                                                className="py-2 px-4"
                                                                onClick={() =>
                                                                    window.open(`${selectedRow?.invoice_url}`)
                                                                }
                                                                disabled={!selectedRow || !selectedRow.invoice_number}
                                                                style={{ display: 'flex', flexDirection: 'row' }}>
                                                                <ListItemIcon>
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M4.50006 9C4.22392 9 4.00006 9.22386 4.00006 9.5V11.5C4.00006 11.7761 4.22392 12 4.50006 12C4.7762 12 5.00006 11.7761 5.00006 11.5V11.3336H5.33326C5.97767 11.3336 6.50006 10.8112 6.50006 10.1668C6.50006 9.52239 5.97767 9 5.33326 9H4.50006ZM5.33326 10.3336H5.00006V10H5.33326C5.42538 10 5.50006 10.0747 5.50006 10.1668C5.50006 10.2589 5.42538 10.3336 5.33326 10.3336ZM10.0008 9.49937C10.0011 9.22347 10.2249 9 10.5008 9H11.4991C11.7752 9 11.9991 9.22386 11.9991 9.5C11.9991 9.77614 11.7752 10 11.4991 10H11.0001L10.9997 10.3345H11.4991C11.7752 10.3345 11.9991 10.5583 11.9991 10.8345C11.9991 11.1106 11.7752 11.3345 11.4991 11.3345H11.0004L11.0008 11.4987C11.0015 11.7749 10.7782 11.9993 10.502 12C10.2259 12.0007 10.0015 11.7774 10.0008 11.5013L9.99908 10.8339L10.0008 9.49937ZM7.49866 9C7.22252 9 6.99866 9.22386 6.99866 9.5V11.5C6.99866 11.7761 7.22252 12 7.49866 12H8.0001C8.82853 12 9.5001 11.3284 9.5001 10.5C9.50011 9.67158 8.82854 9 8.0001 9H7.49866ZM7.99866 11V10H8.0001C8.27625 10 8.50011 10.2239 8.5001 10.5C8.5001 10.7761 8.27625 11 8.0001 11H7.99866ZM2.00006 2C2.00006 0.895431 2.89549 0 4.00006 0H8.58585C8.98367 0 9.3652 0.158035 9.64651 0.43934L13.5607 4.35355C13.842 4.63486 14.0001 5.01639 14.0001 5.41421V7.08165C14.582 7.28793 14.9988 7.84321 14.9988 8.49585V12.499C14.9988 13.1517 14.582 13.707 14.0001 13.9132V14C14.0001 15.1046 13.1046 16 12.0001 16H4.00006C2.89549 16 2.00006 15.1046 2.00006 14V13.9132C1.4182 13.7069 1.00146 13.1516 1.00146 12.499V8.49585C1.00146 7.84326 1.4182 7.28801 2.00006 7.0817V2ZM13.0001 6H9.50006C8.67163 6 8.00006 5.32843 8.00006 4.5V1H4.00006C3.44778 1 3.00006 1.44772 3.00006 2V6.99585H13.0001V6ZM3.00006 13.999C3.00006 14.5513 3.44778 15 4.00006 15H12.0001C12.5523 15 13.0001 14.5513 13.0001 13.999H3.00006ZM9.00006 1.20711V4.5C9.00006 4.77614 9.22392 5 9.50006 5H12.793L9.00006 1.20711ZM2.50146 7.99585C2.22532 7.99585 2.00146 8.21971 2.00146 8.49585V12.499C2.00146 12.7752 2.22532 12.999 2.50147 12.999H13.4988C13.7749 12.999 13.9988 12.7752 13.9988 12.499V8.49585C13.9988 8.21971 13.7749 7.99585 13.4988 7.99585H2.50146Z" fill="#344054" />
                                                                    </svg>
                                                                </ListItemIcon>
                                                                <ListItemText primary={<span style={{ fontSize: '14px', fontFamily: 'inherit', fontWeight: 500 }}>Download Invoice</span>} />
                                                            </MenuItem>
                                                            <MenuItem
                                                                className="py-2 px-4"
                                                                onClick={() => {
                                                                    setAnchorEl(null)
                                                                    setInvoiceNumber(selectedRow.invoice_number)
                                                                    setMailData(prevMailData => ({
                                                                        ...prevMailData,
                                                                        email: '' // Set email to blank
                                                                    }));
                                                                    setApiError('')
                                                                    setSendInvoiceModal(true)

                                                                }}
                                                                disabled={!selectedRow || !selectedRow.invoice_number}
                                                                style={{ display: 'flex', flexDirection: 'row' }}>
                                                                <ListItemIcon>
                                                                    <MailOutlineIcon />
                                                                </ListItemIcon>
                                                                <ListItemText
                                                                    primary={<span style={{ fontSize: '14px', fontFamily: 'inherit', fontWeight: 500 }}>Send Invoice</span>}
                                                                />
                                                            </MenuItem>
                                                            <MenuItem
                                                                className="py-2 px-4"
                                                                onClick={() => deleteInvoice(selectedRow.invoice_number)}
                                                                disabled={!selectedRow || !selectedRow.invoice_number}
                                                                style={{ display: 'flex', flexDirection: 'row' }}>
                                                                <ListItemIcon>
                                                                    <DeleteIcon />
                                                                </ListItemIcon>
                                                                <ListItemText
                                                                    primary={<span style={{ fontSize: '14px', color: '#D92D20', fontFamily: 'inherit', fontWeight: 500 }}>Delete Invoice</span>}
                                                                />
                                                            </MenuItem>

                                                        </Menu>

                                                    </div>

                                                </div>
                                                <Modal show={sendInvoiceModal}>
                                                    <Modal.Header>

                                                        <h1>Send Invoice</h1>
                                                    </Modal.Header>
                                                    <form onSubmit={handleEmailInvoice}>
                                                        <Modal.Body>
                                                            <div className="form-group">
                                                                <label className="required form-label">Email Address</label>
                                                                <input
                                                                    type="email"
                                                                    className="form-control"
                                                                    placeholder="Enter Email Address"
                                                                    value={mailData.email}
                                                                    onChange={(e) => setMailData({ ...mailData, email: e.target.value })}
                                                                    name="email"
                                                                    required
                                                                />
                                                                {errorForm && errorForm.email && (
                                                                    <div className="text-danger fs-5 mt-2">{errorForm.email}</div>
                                                                )}
                                                            </div>
                                                        </Modal.Body>
                                                        <Modal.Footer>
                                                            <div className="col-md-12"> {errorDiv} </div>
                                                            <div className="col-md-12 text-center">

                                                                <button
                                                                    type="submit"
                                                                    id="kt_modal_new_address_submit"
                                                                    className="btn btn-primary me-3 w-45"
                                                                    disabled={loading}
                                                                >
                                                                    Send
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    onClick={() => setSendInvoiceModal(false)}
                                                                    id="kt_modal_new_max_discount_value_submit"
                                                                    className="btn btn-danger me-l w-45"

                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>

                                                        </Modal.Footer>
                                                    </form>

                                                </Modal>
                                            </div>
                                        </div>
                                    </div>
                                </main>
                                </div>
                            </div>
                        </div>
                        <GroupAdminUperSide />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}



export default GroupAdminTourGroupReport;

